<section class="orchestration-shell">
  <header class="shell-header">
    <div>
      <h1>{{ (canOrchestrate() ? 'Orchestration' : 'Access') | translate }}</h1>
      @if (canOrchestrate()) {
        <p>{{ 'Assignments, subscriptions, workers, and resource limits' | translate }}</p>
      }
    </div>
    <a class="admin-link" [routerLink]="isAdmin ? '/admin' : '/main-menu'"><i class="pi pi-arrow-left"></i>{{ (isAdmin ? 'Administration' : 'Main menu') | translate }}</a>
  </header>

  <nav class="orchestration-nav" [attr.aria-label]="'Orchestration navigation' | translate">
    @for (link of links(); track link.url) {
      <a
        [routerLink]="link.url"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
        [routerLinkActiveOptions]="{ exact: link.url === '/admin/process-management' }">
        <i [class]="link.icon" aria-hidden="true"></i>
        <span>{{ link.label | translate }}</span>
      </a>
    }
  </nav>

  <main class="shell-content"><router-outlet></router-outlet></main>
</section>
